<template>
  <v-dialog v-model="visible" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text :class="`${color}--text`">
        {{ $t('Please Wait') }}
        <v-progress-linear indeterminate :color="color" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    theme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getGeneralState']),
    color() {
      // TODO: TRY REMOVING THIS.THEME
      return this.theme ? 'lightText' : (this.getGeneralState('theme_dark') ? 'lightText' : 'primaryText')
    }
  }
}
</script>
